import getAlignOffset from './getAlignOffset';
import type { ParsedPlacement } from './parsePlacement';
import resolveAutoSide from './resolveAutoSide';
import type { FloatingSide } from './FloatingPlacement';

export type MeasuredPlacement = {
  side: FloatingSide;
  alignOffset: number;
};

export const FALLBACK_PLACEMENT: MeasuredPlacement = { side: 'top', alignOffset: 0 };

const measurePlacement = (trigger: HTMLElement, placement: ParsedPlacement): MeasuredPlacement => {
  const triggerRect = trigger.getBoundingClientRect();
  const viewport = { width: document.documentElement.clientWidth, height: window.innerHeight };
  const side = placement.side ?? resolveAutoSide(triggerRect, viewport);

  return {
    side,
    alignOffset: getAlignOffset({ side, align: placement.align, triggerSize: triggerRect }),
  };
};

export default measurePlacement;
